module.exports = __webpack_public_path__ + "static/img/pic-bg-5.497a1ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-5.png
// module id = GVPH
// module chunks = 0